export const REQUEST_CREATE_TOKEN_STRIPE_FINISHED =
  "REQUEST_CREATE_TOKEN_STRIPE_FINISHED";
export const REQUEST_CREATE_TOKEN_STRIPE = "REQUEST_CREATE_TOKEN_STRIPE";
export const PRE_CREATE_TOKEN_STRIPE = "PRE_CREATE_TOKEN_STRIPE";
export const CREATE_TOKEN_STRIPE = "CREATE_TOKEN_STRIPE";
